//todo: refactor axios usage to use singleton pattern
const axios = require('axios');

const URL = 'https://fcd.terra.dev/v1/staking/validators/';
const validatorCache = new Map();

function cacheHasAndIsValid(validator) {
    return validatorCache.has(validator) &&
        validatorCache.get(validator).expiresAt > Date.now();
}

async function getValidatorDetails(validator) {
    if (cacheHasAndIsValid(validator)) {
        return validatorCache.get(validator).data;
    }
    const config = {
        method: 'get',
        url: URL + validator,
        headers: {}
    };
    const response = await axios(config);
    validatorCache.set(validator, {
        expiresAt: new Date(new Date().getTime() + (24 * 3600 * 1000)),
        data: response.data
    });
    // console.log(response.data);
    return response.data
}

const mapValidators = async (validators) => {
    const mappedValidatorPromises = validators
        .map((validator) => {
            return mapValidator(validator);
        });
    return Promise.all(mappedValidatorPromises);
}

const mapValidator = async (validator) => {
    return getValidatorDetails(validator)
        .then((data) => {
            return {validator, ...data.description}
        });
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {mapValidators, mapValidator};
